import type { BookingMessages } from "@/i18n/types";
import { de } from "@/i18n/de";

const LABELS: Record<string, string> = getBookingStatusLabels(de);

export function getBookingStatusLabels(messages: BookingMessages): Record<string, string> {
  return { ...messages.bookingStatus };
}

export function bookingStatusLabel(status: string): string {
  return LABELS[status] ?? status;
}
